var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 6.09998C9.75 5.68576 9.41421 5.34998 9 5.34998C8.58579 5.34998 8.25 5.68576 8.25 6.09998V9.18331C8.25 9.59752 8.58579 9.93331 9 9.93331C9.41421 9.93331 9.75 9.59752 9.75 9.18331V6.09998ZM10 12.3328C10 12.8851 9.55228 13.3328 9 13.3328C8.44772 13.3328 8 12.8851 8 12.3328C8 11.7805 8.44772 11.3328 9 11.3328C9.55228 11.3328 10 11.7805 10 12.3328Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3168 0.992523L17.0075 5.68321V12.3168L12.3168 17.0075H5.68318L0.992493 12.3168L0.992493 5.68321L5.68318 0.992524L12.3168 0.992523ZM6.3045 2.49252L2.49249 6.30453V11.6955L6.3045 15.5075H11.6955L15.5075 11.6955V6.30453L11.6955 2.49252L6.3045 2.49252Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/iconError.8700c3c4a378c303f99566857a032615.svg";
export { ForwardRef as ReactComponent };